module.exports = __webpack_public_path__ + "img/description1.8d67a70d.jpg";